




































































































































import Vue from 'vue'
import { copyText } from '@/utils'
import CreateSubAcc from './CreateSubAcc.vue'
import MenuTable from './MenuTable'
import { TenantAppServiceProxy,AppMenuServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import {
  MasterlinkRoleServiceProxy,
  SyncAccountDataScopeDTO,
  SubAccountServiceProxy,
  IdsDTO,
  AuthorityDomainServiceProxy
} from '@/service-proxies/app-v2/system.service-proxies'
import { Empty } from 'ant-design-vue'
import * as _ from 'lodash'

const subAccountServiceProxy = new SubAccountServiceProxy()
const roleServiceProxy = new MasterlinkRoleServiceProxy()
const appMenuServiceProxy = new AppMenuServiceProxy()
const tasp = new TenantAppServiceProxy()
const authorityDomainServiceProxy = new AuthorityDomainServiceProxy()
export default Vue.extend({
  name: 'SubAccountSet',
  components: { CreateSubAcc, MenuTable },
  data() {
    return {
      accountList: [],
      selectedAcc: [],
      showCreateModal: false,
      pwdVisible: false,
      appData: [],
      currentApp: '',
      tableLoading: false,
      syncLoading: false,
      permissionData: [],
      authorityTree: [],
      deptNamesArr: [], // 职权域名数组
      deptNames: '', // 职权域名字符串
      Empty,
      editDeptNames: false,
      deptId: undefined
    }
  },
  computed: {
    selectedAccItem() {
      return this.accountList.find((item) => item.id === this.selectedAcc[0])
    }
  },
  created() {
    this.getAllData()
  },
  watch: {
    selectedAccItem: {
      handler(val) {
        this.deptNamesArr = []
        this.deptNames = ''
        this.pwdVisible = false
        if (val && val.deptId !== null && this.authorityTree) {
          const deptIdArr = val.deptId.split(',')
          deptIdArr.map((id) => this.getDeptNames(this.authorityTree, id))
          this.deptNames = this.deptNamesArr.join(',')
        }
      },
      immediate: true
    }
  },
  methods: {
    // 编辑职权域
    editDept() {
      this.editDeptNames = true
    },
    // 选择职权域
    onChange(value) {
      this.deptId = value
    },
    // 保存职权域
    async saveDept() {
      const grantDeptIdList = this.deptId.map(res => {return res})
      const values: any = {
        grantDeptIdList: grantDeptIdList,
        id: this.selectedAcc[0]
      }
      await subAccountServiceProxy.updateDept(values)
      this.deptId = undefined
      this.editDeptNames = false
      this.resetApp()
      // this.getSubAccountDetail()
      this.getAppAuthorizedMenus()
      this.getSubAccountList()
    },
    // 获取账户列表
    async getSubAccountList() {
      this.accountList = []
      // this.selectedAcc = []
      const res = await subAccountServiceProxy.list()
      this.accountList = res.list
      if (this.accountList.length && !this.selectedAcc.length) {
        this.selectedAcc.push(this.accountList[0].id)
      }
      // this.getSubAccountDetail()
    },
    // 获取账户详情
    async getSubAccountDetail() {
      if (!this.selectedAcc.length) {
        return
      }
      const res = await subAccountServiceProxy.detail(this.selectedAcc[0])
    },
    // 获取app列表
    async loadAppData() {
      const res = await tasp.getCurrentTenantGrantApps()
      this.appData = res
      this.resetApp()
    },
    async getAllData() {
      await this.getAuthorityTree()
      Promise.allSettled([this.getSubAccountList(), this.loadAppData()]).then((res) => {
        this.getAppAuthorizedMenus()
      })
    },
    // 新建或删除账户之后重新获取账户列表和菜单列表
    update() {
      this.resetApp()
      Promise.all([this.getSubAccountList()]).then((res) => {
        this.getAppAuthorizedMenus()
      })
    },
    // 获取菜单列表
    async getAppAuthorizedMenus() {
      this.permissionData = []
      if (!this.selectedAccItem || !this.currentApp) {
        return
      }
      this.tableLoading = true
      try {
        const res = await appMenuServiceProxy.getAppAuthorizedMenus(
          this.currentApp,
          this.selectedAccItem.roleId
        )
        this.permissionData = _.cloneDeep(res.menuTree)
        this.tableLoading = false
      } catch (e) {
        this.tableLoading = false
      }
    },
    // 打开新建窗口
    createAccount() {
      this.showCreateModal = true
    },
    // 关闭新建窗口
    cancel(data?: any) {
      this.showCreateModal = false
      if (data && data.reload) {
        if (data.newId) {
          this.selectedAcc = []
          this.selectedAcc.push(data.newId)
        }
        this.update()
      }
    },
    // 切换账户
    changeMenu({ key }) {
      this.selectedAcc = []
      this.selectedAcc.push(key)
      this.resetApp()
      // this.getSubAccountDetail()
      this.getAppAuthorizedMenus()
    },
    // 切换app
    changeApp(key: string) {
      this.getAppAuthorizedMenus()
    },
    // 删除账户
    async handleDelete(record) {
      const params = []
      params.push(record.id)
      await subAccountServiceProxy.delete(new IdsDTO({ idList: params }))
      this.$message.success(this.$t('page_resource_pool_success'))
      this.selectedAcc = []
      this.update()
    },
    // 重置app选中项
    resetApp() {
      if (this.appData && this.appData.length) {
        this.currentApp = this.appData[0].appCode
      }
    },
    // 获取已分配给我的职权域的树
    async getAuthorityTree() {
      this.authorityTree = []
      const res = await authorityDomainServiceProxy.getAssignedTreeList()
      if (res && res.data.length) {
        res.data.forEach((element) => {
          this.authorityTree.push(this.createNode(element))
        })
      }
    },
    createNode(item: any) {
      const key = item.id
      const title = item.title
      const value = item.id
      const children = item.children

      const node = {
        key: key,
        value: value,
        title: title,
        children: children
      }

      if (children != null) {
        const length = children.length
        if (length > 0) {
          const childrenList = []
          for (let i = 0; i < length; i++) {
            childrenList[i] = this.createNode(children[i])
          }

          node.children = childrenList
        }
      }
      return node
    },
    // 根据职权域id获取职权域名称
    getDeptNames(data: any, id: any) {
      data.map((item) => {
        if (item.key === id) {
          this.deptNamesArr.push(item.title)
        }
        if (item.children && item.children.length) {
          this.getDeptNames(item.children, id)
        }
      })
    },
    copyPwd() {
      copyText(this.selectedAccItem.secretKey)
      this.$message.success(this.$t('page_my_document_copysuccess'))
    },
    async syncParentRoleSetting() {
      this.syncLoading = true
      await roleServiceProxy
        .syncAccountDataScope(
          new SyncAccountDataScopeDTO({ subAccountRoleId: this.selectedAccItem.roleId })
        )
        .then(this.$message.success(this.$t('sync_success')))
        .finally(() => (this.syncLoading = false))
    }
  }
})
